import React, { Suspense } from 'react'

import StyledAdminWrapper from './StyledAdminWrapper'
import AWCMembershipMetricsEntry from 'components_v2/Admin/AWCMembershipMetrics/AWCMembershipMetricsEntry'

const AWCMembershipWrapper = () => (
  <StyledAdminWrapper>
    <Suspense fallback=''>
      <AWCMembershipMetricsEntry />
    </Suspense>
  </StyledAdminWrapper>
)

export default AWCMembershipWrapper
